module.exports = __webpack_public_path__ + "img/useful_hero_sm.12c2c0a3.png";